import { useEffect, useRef } from 'react';

import { useStoreContext } from 'features/store';

import { ServiceMode } from 'generated/graphql-gateway';
import { useOrderContext } from 'state/order';
import { useServiceModeLive } from 'state/service-mode';

import { isDeliveryQuoteOrAddressStale } from './delivery-reprice-utils';
import { useCheckoutContext } from './use-checkout-context';
import { useCheckoutPriceOrder } from './use-checkout-price-order';

export const useCheckoutStoreChangeReprice = () => {
  const { checkoutRepriceRequestId, deliveryAddress, quoteId } = useOrderContext();
  const serviceMode = useServiceModeLive();
  const { store } = useStoreContext();
  const { serverOrder } = useCheckoutContext();
  const { priceCheckoutOrderForStoreChange } = useCheckoutPriceOrder();
  const lastHandledRequestIdRef = useRef(0);
  const selectedStoreNumber = store?.number ?? null;
  const serverOrderStoreNumber =
    serverOrder?.cart?.storeDetails?.storeNumber ??
    serverOrder?.cart?.storeId?.toString?.() ??
    null;
  const serverOrderDeliveryQuoteId = serverOrder?.delivery?.quoteId ?? null;
  const isDeliveryQuoteStale = Boolean(
    serviceMode === ServiceMode.DELIVERY &&
      isDeliveryQuoteOrAddressStale({
        quoteId,
        serverOrderDeliveryQuoteId,
        deliveryAddress,
        serverOrderDropoff: serverOrder?.delivery?.dropoff,
      })
  );

  useEffect(() => {
    if (
      !checkoutRepriceRequestId ||
      lastHandledRequestIdRef.current >= checkoutRepriceRequestId ||
      !serverOrder?.rbiOrderId ||
      !serviceMode ||
      !selectedStoreNumber ||
      !serverOrderStoreNumber
    ) {
      return;
    }

    if (selectedStoreNumber === serverOrderStoreNumber && !isDeliveryQuoteStale) {
      lastHandledRequestIdRef.current = checkoutRepriceRequestId;
      return;
    }

    const didQueueReprice = priceCheckoutOrderForStoreChange(serviceMode);
    if (didQueueReprice) {
      lastHandledRequestIdRef.current = checkoutRepriceRequestId;
    }
  }, [
    checkoutRepriceRequestId,
    isDeliveryQuoteStale,
    priceCheckoutOrderForStoreChange,
    serverOrder?.rbiOrderId,
    selectedStoreNumber,
    serviceMode,
    serverOrderStoreNumber,
  ]);
};
